export const EXTENSION_TYPES = Object.freeze({
  CALL_WAITING: "call-waiting",
  FORWARDING_RULES: "forwarding-rules",
  RECORDING_SETTINGS: "recording-settings",
  ALLOWED: "allowed",
});

export const EXTENSIONS = "EXTENSIONS";

export const RECORDING_ANNOUNCEMENTS = Object.freeze({
  BOTH_PARTIES: "Both Parties",
  ME: "Me/User",
  REMOTE_PARTY: "Remote Party",
  NEITHER: "Neither",
});

export const RULE_CONDITIONS = Object.freeze({
  BUSY: "BUSY",
  OUTAGE: "OUTAGE",
  NO_ANSWER: "NO_ANSWER",
});

export const RULE_CONTROLS = Object.freeze({
  ON: "ON",
  OFF: "OFF",
});

export const DESTINATION_TYPES = Object.freeze({
  VOICEMAIL: "VOICEMAIL",
  AUTO_ATTENDANT: "AUTO_ATTENDANT",
  EXTENSION: "EXTENSION",
  EXTERNAL_NUMBER: "EXTERNAL_NUMBER",
  DROP_CALL: "DROP_CALL",
});
